<template>
  <div>
    <vue-portal to="hrsys-navbar">
      <div class="flex text-2xl font-bold text-center">
        <base-back-button/>
        <vs-navbar class="flex flex-col sm:flex-row" type="shadow" v-model="activeItem">
          <base-header-title :title="$t('maintenancePayments.maintenancePayment')"/>
          <div class="flex" v-if="maintenancePaymentId">
            <vs-navbar-item index="maintenancePaymentDetails">
              <router-link :to="{name: 'maintenancePaymentDetails'}" replace tag="a">{{
                $t('maintenancePayments.details') }}
              </router-link>
            </vs-navbar-item>
            <vs-navbar-item index="maintenancePaymentTransactions">
              <router-link :to="{name: 'maintenancePaymentTransactions'}" replace tag="a">{{
                $t('maintenancePayments.transactions') }}
              </router-link>
            </vs-navbar-item>
          </div>
        </vs-navbar>
      </div>
    </vue-portal>
    <router-view/>
  </div>
</template>

<script>
  import AuthService from '../../services/Auth';
  import {ADMIN_ROLE, FINANCE_ROLE} from "../../middlewares/permissions";

  export default {
    name: "MaintenancePayment",
    data: () => ({
      activeItem: null,
      maintenancePaymentId: null
    }),
    methods: {
      getRouteDetails () {
        this.activeItem = this.$route.name;
        this.maintenancePaymentId = parseInt(this.$route.params.id);
      },
      hasFinanceRole () {
        return AuthService.hasOneOfRoles(ADMIN_ROLE, FINANCE_ROLE);
      }
    },
    mounted () {
      this.getRouteDetails()
    },
    updated () {
      this.getRouteDetails()
    }
  }
</script>

<style scoped>

</style>
